import { ApplicationNameDto } from "../dtos/applicationNamesDto";

const APPLICATION_LOOKUP_STORAGE_KEY = "gmscm.application.lookup.details";

interface StoredApplicationDetails {
  dbConnectionNames: string[];
  elasticConnectionNames: string[];
}

type StoredApplicationDetailsMap = Record<string, StoredApplicationDetails>;

function readStoredApplicationDetails(): StoredApplicationDetailsMap {
  if (typeof window === "undefined") return {};

  try {
    const value = window.localStorage.getItem(APPLICATION_LOOKUP_STORAGE_KEY);
    if (!value) return {};

    const parsed = JSON.parse(value) as StoredApplicationDetailsMap;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeStoredApplicationDetails(value: StoredApplicationDetailsMap): void {
  if (typeof window === "undefined") return;

  try {
    window.localStorage.setItem(APPLICATION_LOOKUP_STORAGE_KEY, JSON.stringify(value));
  } catch {
    // Ignore storage errors so lookup UI still functions.
  }
}

export function mergeWithStoredApplicationDetails(applications: ApplicationNameDto[]): ApplicationNameDto[] {
  const stored = readStoredApplicationDetails();

  return applications.map((application) => {
    const details = stored[application.name];
    return {
      ...application,
      dbConnectionNames:
        application.dbConnectionNames && application.dbConnectionNames.length > 0
          ? application.dbConnectionNames
          : details?.dbConnectionNames ?? [],
      elasticConnectionNames:
        application.elasticConnectionNames && application.elasticConnectionNames.length > 0
          ? application.elasticConnectionNames
          : details?.elasticConnectionNames ?? [],
    };
  });
}

export function saveApplicationDetails(applications: ApplicationNameDto[]): void {
  const stored = readStoredApplicationDetails();
  const next: StoredApplicationDetailsMap = {};

  for (const application of applications) {
    const previous = stored[application.name];
    next[application.name] = {
      dbConnectionNames: application.dbConnectionNames ?? previous?.dbConnectionNames ?? [],
      elasticConnectionNames: application.elasticConnectionNames ?? previous?.elasticConnectionNames ?? [],
    };
  }

  writeStoredApplicationDetails(next);
}

